import rulesSecurityEn from './rulesSecurity.en'

export default function createLendingBundle({ whitepaper, yieldLadder }) {
  return {
    lendingContent: {
      yieldLadder,
      whitepaper,
      rulesSecurity: rulesSecurityEn,
    },
  }
}
